import { FC } from "react";
import { Button, Modal } from "react-bootstrap";
import "./styles.scss";

export interface BasicModalProps {
  text: string;
  handleClose: () => void;
  show: boolean;
}
const BasicModal: FC<BasicModalProps> = ({ text, handleClose, show }) => {
  return (
    <Modal show={show} onHide={handleClose} size="sm" centered>
      <Modal.Body className="d-flex flex-column justify-content-center align-items-center m-3">
        <div id="text-container">{text}</div>
        <Button variant="secondary" className="mt-4" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default BasicModal;
